import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { Redirect }         from 'react-router'
import HomeProfessor        from "./professor/home_professor/home_professor";
import HomeAluno            from "./aluno/home/home_aluno";


class Index extends Component {

    constructor(props){
        super(props);
        this.state = {load:false}
    }

    renderComponets(){

        if (!this.props.sesison) {
            return (<Redirect to={'/login'}/>);
       }

        const obj = {}
       switch (this.props.sesison.perfil) {
          
           case this.props.config.userProfessor:
             obj.acao = <HomeProfessor/>;
           break;

           case this.props.config.userAluno:
             obj.acao = <HomeAluno/>;
           break;
          
           default:
              obj.acao = <h1>Nenhum componente selecionado.</h1>;
           break;
       }
       return  obj.acao;
    }




    render() {
    
        return (<div>  {this.renderComponets()} </div>);
    }
}

function mapStateToProps(state){

    return {
             isAuthenticated : state.auth.isAuthenticated,
             sesison         : state.auth.session,
             menu            : state.configReducer.menu,
             checkSelect        : state.scopoReducer.checkSelect == null,
             config          : state.configReducer.config
           };
}

export default connect(mapStateToProps)(Index);




// WEBPACK FOOTER //
// ./src/components/index.js